var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{fill:_vm.fill},attrs:{"id":"app"}},[_c('map-view',{attrs:{"mapboxId":"ckvi9q99p1zdi28ufy8q1cwv5","styleId":"ckvib55po03a514o9idwcfpoz","fill":_vm.fill}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }